export const checkIsChartResponseEmpty = (dataSets) => {
  for (const data of dataSets) {
    const {data: points, label} = data
    if (label === '') return false
    for (let i = 0; i < points?.length; i = i + 3) if (points[i] != null) return false
  }
  return true
}

const findMinMaxOfX = (data) => {
  if (data?.length === 0) return [18, 23]
  const xMin = []
  const xMax = []
  for (const obj of data || []) {
    const xAxis = obj?.length ? obj?.map((d) => Number.parseInt(d.DATA_BRICK.toString().slice(0, 2))) : null
    xMin.push(xAxis ? Math.min(...xAxis) : 18)
    xMax.push(xAxis ? Math.max(...xAxis) : 23)
  }
  return [Math.min(...xMin), Math.max(...xMax)]
}

const findMinMaxOfY = (data, name) => {
  if (data?.length === 0) return [0, 90000]
  const yMin = []
  const yMax = []
  for (const obj of data || []) {
    const yAxis = obj?.length ? obj?.map((d) => d[name]) : null
    yMin.push(yAxis ? Math.min(...yAxis) : 0)
    yMax.push(yAxis ? Math.max(...yAxis) : 90000)
  }
  return [Math.min(...yMin), Math.max(...yMax)]
}

export const generateLabels = (data, name) => {
  const xLables = []
  const xLablesWithDates = []
  const [xMin, xMax] = findMinMaxOfX(data)
  for (let i = xMin; i <= xMax; i++) {
    const value = 2000 + i
    xLables.push(value)
    for (let i = 1; i < 12; i++) {
      xLables.push('')
    }
    xLablesWithDates.push('', '', '', 'March ' + value, '', '', '', '', '', 'September ' + value, '', '')
  }
  xLables.push(Number.parseInt('20' + (xMax + 1)))
  xLablesWithDates.push('')
  const [yMin, yMax] = findMinMaxOfY(data, name)
  return [xLables, xLablesWithDates, yMin, yMax]
}

export const generateData = (data, xLables, name) => {
  const sortedData = [...data].sort((a, b) => {
    return a.DATA_BRICK.localeCompare(b.DATA_BRICK)
  })
  const set = []
  for (let i = 0; i < xLables?.length / 12; i = i + 1) {
    set.push(
      null,
      null,
      null,
      Number.parseFloat(sortedData[i * 2]?.[name]),
      null,
      null,
      null,
      null,
      null,
      Number.parseFloat(sortedData[i * 2 + 1]?.[name]),
      null,
      null
    )
  }
  return set
}

export const generateAriaLabelForChart = (filter, selectedCounty, selectedState, sliderValue = null) => {
  return (
    `This chart displays ${filter} data for ${selectedCounty} of ${selectedState} per 100k population ` +
    (sliderValue ? `between the risk range of ${sliderValue?.[0]} and ${sliderValue?.[1]}` : '')
  )
}

export const convertDatasetForTable = (dataSets, date, currentSelections) => {
  dataSets = dataSets.map((value) => ({...value, data: value.data.filter((entry) => entry !== null)}))
  let colName = dataSets.map((value) => ({label: value.label, dataKey: value.label, numeric: true}))
  const filteredDates = date.filter((d) => d !== '')
  const checkIsRiskSelection = Object.hasOwn(currentSelections, 'healthCondition_name')
  const isCountySelected = currentSelections.county_name !== 'All Counties'
  const data = []
  for (let i = 0; i < filteredDates.length; i++) {
    const obj = {}
    for (let j = 0; j < dataSets.length; j++) {
      obj[colName[j].label] = Number.parseInt(dataSets[j].data[i])
    }

    obj.date = filteredDates[i]
    obj.state = currentSelections.state_name
    obj.filter = checkIsRiskSelection ? currentSelections.healthCondition_name : currentSelections.sdoh_name
    isCountySelected && (obj.county = currentSelections.county_name)
    data.push(obj)
  }

  colName = [
    {label: 'Date', dataKey: 'date', numeric: false},
    ...colName,
    {label: 'State', dataKey: 'state', numeric: false},
    ...(isCountySelected ? [{label: 'County', dataKey: 'county', numeric: false}] : []),
    {
      label: checkIsRiskSelection ? 'Health and Equity Condition' : 'Social Driver of Health',
      dataKey: 'filter',
      numeric: false
    }
  ]
  return {data, colName}
}

/* Function Descriptions:
  - checkIsChartResponseEmpty: Checks if the chart response data is empty or invalid.
  - findMinMaxOfX: Finds the minimum and maximum X-axis values from the dataset.
  - findMinMaxOfY: Finds the minimum and maximum Y-axis values for a specific field in the dataset.
  - generateLabels: Generates X-axis labels and Y-axis range for the chart based on the dataset.
  - generateData: Converts the dataset into a format suitable for chart plotting.
  - generateAriaLabelForChart: Creates an accessible aria-label for the chart based on filters and selections.
  - convertDatasetForTable: Converts chart data into a tabular format for display.
*/
